module.exports = __webpack_public_path__ + "img/mdi_point-of-sale.7374b9fc.svg";